export default __webpack_public_path__ + "static/media/soja.5451fdec.svg";